import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

class App extends Component {
    render() {
        return (
            <div className="sid-verification-form">
                <VerificationForm programId={programId} />
            </div>
        );
    }
}

export default App;
